const search = document.querySelector('.js-header-search')
const button = document.querySelector('.js-header-search-open')
const input = document.querySelector('.js-header-search-input')

function init () {
  button.setAttribute('aria-controls', input.id)

  button.addEventListener('click', expand)
  input.addEventListener('focus', expand)
  input.addEventListener('blur', () => !input.value && contract())
  input.addEventListener('input', () => {
    if (input.value) {
      search.classList.add('has-value')
    } else {
      search.classList.remove('has-value')
    }
  })

  if (input.value) {
    expand()
  }
}

function expand () {
  search.classList.add('is-expanded')
  button.setAttribute('aria-expanded', 'true')
  input.focus()
}

function contract () {
  search.classList.remove('is-expanded')
  button.setAttribute('aria-expanded', 'false')
}

if (search && button && input) {
  init()
}
